<template>
  <Modal :open="open" @close="close">
    <div v-if="claim.fraudSuspicion">
      <p class="text-center text-gray-600 mb-6">{{ t("unflag_confirmation") }}</p>

      <div class="flex justify-center space-x-4">
        <SecondaryButton @click="close">{{ t("cancel_button") }}</SecondaryButton>
        <GenericButton data-test="submit" @click="submit">{{ t("unflag_button") }}</GenericButton>
      </div>
    </div>

    <div v-else>
      <p class="text-center text-gray-600 mb-6">{{ t("flag_description") }}</p>

      <div class="mb-6">
        <Textarea
          id="fraudSuspicionReason"
          v-model="reason"
          :label="t('reason_label')"
          label-class="block text-sm font-medium leading-6 text-gray-900"
          :required="true"
          :placeholder="t('reason_placeholder')"
        />
      </div>

      <div class="flex justify-center space-x-4">
        <SecondaryButton @click="close">{{ t("cancel_button") }}</SecondaryButton>
        <GenericButton
          data-test="submit"
          @click="submit"
          :disabled="!reason.trim()"
          class="disabled:cursor-not-allowed"
        >
          {{ t("flag_button") }}
        </GenericButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Modal, GenericButton, SecondaryButton, Textarea } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    Modal,
    GenericButton,
    SecondaryButton,
    Textarea,
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    claim: {
      type: Object,
      required: true,
    },
  },

  emits: ["close"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      reason: "",
    };
  },

  watch: {
    open(newValue) {
      if (newValue) this.reason = "";
    },
  },

  methods: {
    ...mapActions("claims", ["updateFraudSuspicion"]),
    ...mapActions("notifications", ["notify"]),

    async submit() {
      const flagging = !this.claim.fraudSuspicion;

      const response = await this.updateFraudSuspicion({
        fraudSuspicion: flagging,
        reason: flagging ? this.reason.trim() : null,
      });

      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: flagging ? this.t("flag_success") : this.t("unflag_success"),
      });
      this.close();
    },

    close() {
      this.reason = "";
      this.$emit("close");
    },
  },
};
</script>

<i18n src="./FraudSuspicionModal.i18n.json"></i18n>
